import TemplateBlog from './TemplateBlog'

export default TemplateBlog
